export const legalDocuments = [
    {
        title : "Brošura" ,
        link : "https://prodaja.lo.co.me/mps_doc/BrosuraMPS.pdf"
    },{
        title : "Informacija o proizvodu osiguranja (IPID)" ,
        link : "https://prodaja.lo.co.me/mps_doc/IPID MPS 2 Final 2021.pdf"
    },{
        title : "Saglasnost za direktni marketing" ,
        link : "https://prodaja.lo.co.me/uslovi/Saglasnost%20za%20direktni%20marketing.pdf"
    },{
        title : "Obavještenje o obradi podataka" ,
        link : "https://prodaja.lo.co.me/uslovi/Obavje%C5%A1tenje%20o%20obradi%20podataka.pdf"
    },{
        title : "Predugovorno obavještenje" ,
        link : "https://prodaja.lo.co.me/dm/PredugovornoObavjestenje.pdf"
    }
];
